import React from 'react';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import {
  validateBase,
  validateLabel,
  validateReleaseComment,
} from './validations.js';
import { ReleaseVersionType } from '../components/ReleaseCommand/app-flow/types.js';

export const releaseCommand = (
  services: AstroCommandServices,
  cliVersion: string
) => {
  return createCommand('release')
    .description('Release a new version of your application')
    .addOption(
      new Option(
        '--base-url <url>',
        'The base url for when static files have been uploaded to an external cdn'
      )
        .argParser(validateBase)
        .hideHelp()
    )
    .addOption(
      new Option('-l, --label <label>', 'A custom label for this preview')
        .argParser(validateLabel)
        .hideHelp()
    )
    .option(
      '-c, --comment <comment>',
      'The comment for your release version, not visible by users',
      validateReleaseComment
    )
    .addOption(
      new Option(
        '-t, --version-type <type>',
        'The type of version you would like to create'
      ).choices(['major', 'minor'])
    )
    .action(async (options, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { ReleaseCommand } = await import(
        '../components/ReleaseCommand/index.js'
      );

      const { baseUrl, label, comment } = options;

      const versionType = options.versionType
        ? {
            major: ReleaseVersionType.MAJOR,
            minor: ReleaseVersionType.MINOR,
          }[options.versionType]
        : undefined;

      await renderCommand(
        command,
        services,
        cliVersion,
        <ReleaseCommand
          baseUrl={baseUrl}
          label={label}
          comment={comment}
          versionType={versionType}
        />
      );
    });
};
